import { transformObjectValuesToObject } from '../utils/transformObjectValuesToObject';
import { ValuesOf } from '../utils/types';

const LicensingAuthorityTypes = {
  TFL: 'TFL',
  RBWM: 'RBWM',
  Castlepoint: 'Castlepoint',
  Hertsmere: 'Hertsmere',
  Other: 'Other',
} as const;

type TLicensingAuthorityType = ValuesOf<typeof LicensingAuthorityTypes>;

const licensingAuthorityTypesEnum =
  transformObjectValuesToObject<TLicensingAuthorityType>(LicensingAuthorityTypes);

export type { TLicensingAuthorityType };
export { licensingAuthorityTypesEnum, LicensingAuthorityTypes };
